import _ from "lodash";
import { computed } from "mobx";
import { useMemo } from "react";
import { usePipedriveStore, useTenantInMarketStore } from "..";

export default function (ownerFilter: string, searchFilter: string, sortBy: string) {
    const tenantInMarketStore = useTenantInMarketStore();
    const pipedriveStore = usePipedriveStore();

    const ownerFilteredTenantsInMarket = useMemo(() => computed(() => {
        switch (ownerFilter) {
            case "All Owners":
                return tenantInMarketStore.tenantsInMarket;
            case "None":
                return tenantInMarketStore.tenantsInMarket.filter(tim => !tim.assignedToPipedriveUserId);
            default:
                return tenantInMarketStore.tenantsInMarket.filter(tim => pipedriveStore.users.find(u => u.id === tim.assignedToPipedriveUserId)?.name === ownerFilter);
        }
    }), [ownerFilter]).get();

    const sortedTenantsInMarket = useMemo(() => {
        switch (sortBy) {
            case TenantsInMarketSortingType.ModifiedNewest:
                return _.orderBy(ownerFilteredTenantsInMarket, tenantInMarket => tenantInMarket.modifiedDate, "desc");
            case TenantsInMarketSortingType.ModifiedOldest:
                return _.orderBy(ownerFilteredTenantsInMarket, tenantInMarket => tenantInMarket.modifiedDate, "asc");
            default:
                return _.orderBy(ownerFilteredTenantsInMarket, tenantInMarket => tenantInMarket.modifiedDate, "asc");
        }
    }, [ownerFilteredTenantsInMarket, sortBy]);

    return useMemo(() => {
        if (!searchFilter)
            return sortedTenantsInMarket;

        const searchFilterInLowerCase = searchFilter.toLowerCase();

        return sortedTenantsInMarket.filter(tim =>
            (tim.description && tim.description.toLowerCase().includes(searchFilterInLowerCase)) ||
            (tim.pipedriveCompanyId && pipedriveStore.organizations.find(o => o.id === tim.pipedriveCompanyId)?.name.toLowerCase().includes(searchFilterInLowerCase)) ||
            (tim.pipedriveBrokerageId && pipedriveStore.organizations.find(o => o.id === tim.pipedriveBrokerageId)?.name.toLowerCase().includes(searchFilterInLowerCase))
        );
    }, [sortedTenantsInMarket, searchFilter]);
}

export class TenantsInMarketSortingType {
    static ModifiedNewest = "ModifiedNewest";
    static ModifiedOldest = "ModifiedOldest";
}